export default __webpack_public_path__ + "static/media/chi1.ebcaed5a.jpg";